import React from "react";
import MyModal from "../../../../Common/my-modal/my-modal.component";
import ResetPasswordFormWrapper from "./reset-password-form-wrapper";
import { getResetPasswordFormInitialValues } from "../../../../../common/validations/members-access.validations";
import ResetPasswordSuccessContent from "./reset-password-success-content";

interface ModalFormProps {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const ModalForm = ({ onClose, onConfirm, loading }: ModalFormProps) => {
  const temporaryPassword = "Qw134!sSREWRQ";

  return (
    <ResetPasswordFormWrapper
      initialValues={getResetPasswordFormInitialValues(temporaryPassword)}
    >
      {({ values, handleCopyPassword, isValid, handleTemporaryPasswordChange }) => {

        return (
          <MyModal.Body className="p-0">
            <ResetPasswordSuccessContent
              temporaryPassword={values.temporaryPassword}
              onCopyPassword={handleCopyPassword}
              onTemporaryPasswordChange={handleTemporaryPasswordChange}
            />
            <MyModal.Footer className="d-flex gap-4 border-top">
              <MyModal.CancelButton onClick={onClose} disabled={loading}>
                Cancel
              </MyModal.CancelButton>
              <MyModal.ApplyButton onClick={onConfirm} loading={loading} disabled={!isValid || loading}>
                Reset Password
              </MyModal.ApplyButton>
            </MyModal.Footer>
          </MyModal.Body>
        );
      }}
    </ResetPasswordFormWrapper>
  );
};

export default ModalForm;
